export enum SECTIONS_ENUMS {
  DASHBOARD = "Dashboard",
  USERS = "Users",
  EMPLOYEES = "Employees",
  COMPANY = "Company",
  TIME_ATTENDANCE = "Time Attendance",
  COMPANY_PAYROLLS = "Company Payrolls",
  LEAVE_MANAGEMENT = "Leave Management",
  DOCUMENTS = "Documents",
  PERFORMANCE = "Performance",
  PROJECT_BONUSES = "Project Bonuses",
  SUBSCRIPTION = "Subscriptions",
  CHAT = "Chat",
  SETTINGS = "Settings",
  HELP_AND_SUPPORT = "Help & Support",
  TEAMS = "Teams",
  PROJECTS = "Projects",
  HOME = "Home",
  ASSETS = "Assets",
  EVENTS = "Events",
  WORKFLOWS = "Workflows",
  NOTIFICATIONS = "Notifications",
  ANNOUNCEMENTS = "Announcements",
  AI_ASSISTANT = "AI Assistant",
  COMPANY_POLICIES = "Company Policies",
  MARKETPLACE = "Marketplace",
  PAYROLL = "Payroll",
  COMPANY_PAYROLL = "Company Payroll",
  OFFBOARDING = "Offboarding",
  ONBOARDING = "Onboarding",
  FILES = "Files",
  NFC_FORMS = "NFC",
  EXPENSES = "Expenses",
  PROJECT_MANAGEMENT = "Project Management",
  DIGITAL_ID = "Digital ID",
  STUDIO = "Studio",
  BIOMETRIC_DEVICES = "Biometric Devices",
}

export enum PLATFORM_SECTION_ENUM {
  HOME = "home",
  DASHBOARD = "dashboard",
  USERS = "users",
  SUBSCRIPTION = "subscriptions",
  EMPLOYEES = "employees",
  TIME_ATTENDANCE = "time attendance",
  LEAVE_MANAGEMENT = "leave management",
  DOCUMENTS = "documents",
  ASSETS = "assets",
  TEAMS = "teams",
  PERFORMANCE = "performance",
  PROJECTS = "projects",
  CHAT = "chat",
  AI_ASSISTANT = "ai assistant",
  SETTINGS = "settings",
  EVENTS = "events",
  NOTIFICATIONS = "notifications",
  COMPANY = "company",
  OTHER = "other",
  COMPANY_POLICIES = "company policies",
  MARKETPLACE = "marketplace",
  PAYROLL = "Payroll",
  WORKFLOWS = "workflows",
  ANNOUNCEMENTS = "announcements",
  OFFBOARDING = "offboarding",
  ONBOARDING = "onboarding",
  RECRUITMENT = "recruitment",
  HELP_AND_SUPPORT = "help & support",
  NFC_FORMS = "nfc",
  DIGITAL_ID = "digital id",
  EXPENSES = "expenses",
  FILES = "files",
  STUDIO = "studio",
  PROJECT_MANAGEMENT = "project management",
  MY_APP = "my apps",
  SALES_COMMISSIONS = "sales and commissions",
  /** Must stay the lowercased platform_sections.name on the server. */
  DATA_TRANSFER = "data transfer",
  INTEGRATIONS = "integrations",
  /** Must stay the lowercased platform_sections.name on the server —
   * permission matching is by name.toLowerCase(), not by `key` (see
   * AUDIT_LOGS_PLAN.md finding I). */
  AUDIT_LOG = "audit logs",
  /** Must stay the lowercased platform_sections.name on the server. */
  BIOMETRIC_DEVICES = "biometric devices",
  /** Cameras module. Must stay the lowercased platform_sections.name ('Camera'). */
  CAMERA = "camera",
  /** Add-ons module. Must stay the lowercased platform_sections.name ('Add ons'). */
  ADD_ONS = "add ons",
  /**
   * The company setup ("go-live") guide. Must stay the lowercased
   * platform_sections.name ('Company Setup'). Distinct from ONBOARDING above,
   * which is the EMPLOYEE onboarding module.
   */
  COMPANY_SETUP = "company setup",
}

export enum ICON_NAMES {
  DASHBOARD = "dashboard",
}

export enum LeaveRequestTypes {
  ANNUAL = "annual",
  SICK = "sick",
  UNPAID = "unpaid",
  MATERNITY = "maternity",
  PATERNITY = "paternity",
  BEREAVEMENT = "bereavement",
  OTHER = "other",
}

export enum LeaveRequestStatus {
  PENDING = "pending",
  APPROVED = "approved",
  REJECTED = "rejected",
  REVIEW_UPDATE = "review_update",
  REQUEST_UPDATE = "request_update",
}

// Create a type from the values of LeaveRequestTypes
export type LeaveRequestType =
  (typeof LeaveRequestTypes)[keyof typeof LeaveRequestTypes];

export type LeaveRequestsStatus =
  (typeof LeaveRequestStatus)[keyof typeof LeaveRequestStatus];

export enum DAY_TYPE_ENUM {
  WEEKEND = "weekend",
  HOLIDAY = "holiday",
  ABSENT = "absent",
}

export enum DURATION_ENUM {
  WEEKLY = "weekly",
  BI_WEEKLY = "bi-weekly",
  MONTHLY = "monthly",
}

export enum VIEW_TYPE_ENUM {
  LIST = "list",
  GRID = "grid",
}

export enum INVITATION_STATUS {
  OFFER_ACCEPTED = "offer-accepted",
  OFFER_SENT = "offer-sent",
  OFFER_REJECTED = "offer-rejected",
  INVITATION_PENDING = "invitation-pending",
  SUCCESS_FORWARD = "success-forward",
  INTERVIEW_SCHEDULED = "interview-scheduled",
  NOT_SUCCESS_REJECT = "not-success-reject",
  INTERVIEW_ON_HOLD = "interview-on-hold",
  OFFER_LETTER_GENERATED = "offer-letter-generated",
}

export enum ENUM_ASSET_REQUEST_STATUS {
  APPROVED = "approved",
  REJECTED = "rejected",
  PENDING = "pending",
  CANCELLED = "cancelled",
  FULFILLED = "fullfilled",
}

export enum PermissionLevelEnum {
  INDIVIDUAL = "individual",
  COMPANY = "company",
}

export enum PASSWORD_RESET_TOKEN_QUERY_PARAM {
  Param = "token",
}

export enum ENUM_ASSET_STATUS {
  IN_USE = "in-use",
  MAINTENANCE = "maintenance",
  ACTIVE = "active",
  RETIRED = "retired",
  LOST = "lost",
  AVAILABLE = "available",
  DAMAGED = "damaged",
}

export enum LeavePaidType {
  Paid = "paid",
  Unpaid = "unpaid",
  Half = "half-paid",
}

export enum BenefitsFrequencyEnum {
  DAILY = "daily",
  WEEKLY = "weekly",
  MONTHLY = "monthly",
  ANNUALLY = "annually",
}

export enum SocialSecurityBenefitEnum {
  GPSSA = "General Pension And Social Security Authority (GPSSA)",
  ADPF = "Abu Dhabi Pension Fund (ADPF)",
  GOSI = "General Organization for Social Insurance (GOSI)",
  SIO = "Social Insurance Organization (SIO)",
  SPF = "Social Protection Fund (SPF)",
  PIFSS = "Public Institution for Social Security (PIFSS)",
  GRSIA = "General Retirement and Social Insurance Authority (GRSIA)",
}

export enum DeductionFrequencyEnum {
  ONE_TIME = "One-time deduction",
  RECURRING = "Recurring deduction for subsequent Payrolls",
}

export enum AssetCategories {
  Regular = "regular",
  Consumable = "consumable",
}

// Immutable machine identity of system roles (roles.systemKey from the API).
// Matches SYSTEM_ROLE_KEY_ENUM on the backend.
export enum EnumSystemRoleKeys {
  COMPANY_SUPER_ADMIN = "company-super-admin",
  COMPANY_EMPLOYEE = "company-employee",
}

export enum ConsumableCategory {
  PANTRY = "pantry",
  REGULAR = "regular",
  STATIONARY = "stationary",
  CLEANING = "cleaning",
  ACCESSORIES = "accessories",
}

export enum AssetRequestType {
  NEW_REQUEST = "new-request",
  REPLACEMENT_REQUEST = "replacement-request",
  ASSIGN_CONSUMABLE = "assign-consumable",
}

export enum ENUM_ACTIVITY_TYPE {
  LEAVE_REQUEST = "LEAVE_REQUEST",
  ABSENT_TODAY = "ABSENT_TODAY",
  LATE_NOTE = "LATE_NOTE",
  NO_CHECKOUT = "NO_CHECKOUT",
  REGULARIZATION = "REGULARIZATION",
}

export enum DOCUMENT_TYPES {
  OFFER_LETTER = "offer-letter",
  EMPLOYMENT_AGREEMENT = "employment-agreement",
  CONFIDENTIAL_AGREEMENT = "confidential-agreement",
}

export enum CheckInMethodEnum {
  RadiusLocation = "allow_from_radius_location",
  SpecificLocation = "allow_from_location",
}

export enum USER_ACCOUNT_STATUS_ENUM {
  DRAFT = "draft",
  INSTANT = "instant",
  ONBOARDING = "onboarding",
  PENDING = "pending",
  ACTIVE = "active",
  INACTIVE = "inactive",
  OFFBOARDED = "offboarded",
  // SUSPENDED = "suspended",
  // BLOCKED = "blocked",
  // VERIFIED = "verified",
  // DELETED = "deleted",
}

export enum ENUM_PRIORITY_OPTIONS {
  Low = "low",
  Medium = "medium",
  High = "high",
  Urgent = "urgent",
}
